var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs"},_vm._l((_vm.path),function(item,k){return _c('router-link',{key:k,staticClass:"bc neue",attrs:{"to":item.path},domProps:{"innerHTML":_vm._s(item.label)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }